import { render, staticRenderFns } from "./facebook.vue?vue&type=template&id=43c00af1&scoped=true&"
import script from "./facebook.vue?vue&type=script&lang=js&"
export * from "./facebook.vue?vue&type=script&lang=js&"
import style0 from "./facebook.vue?vue&type=style&index=0&id=43c00af1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c00af1",
  null
  
)

export default component.exports